import { createContext, useContext, useEffect, useState } from "react";
import api from "../lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (window.location.hash?.includes("session_id=")) { setLoading(false); return; }
    const token = localStorage.getItem("pti_token");
    if (!token) { setLoading(false); return; }
    api.get("/auth/me")
      .then((r) => setUser(r.data))
      .catch(() => localStorage.removeItem("pti_token"))
      .finally(() => setLoading(false));
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("pti_token", data.token);
    setUser(data.user);
    return data.user;
  };

  const loginWithGoogleSession = async (session_id) => {
    const { data } = await api.post("/auth/google/session", { session_id });
    localStorage.setItem("pti_token", data.token);
    setUser(data.user);
    return { user: data.user, newUser: data.new_user };
  };

  const selectRole = async (role) => {
    const { data } = await api.post("/auth/select-role", { role });
    localStorage.setItem("pti_token", data.token);
    setUser(data.user);
    return data.user;
  };

  const becomeCreator = async () => {
    const { data } = await api.post("/auth/upgrade-to-creator");
    localStorage.setItem("pti_token", data.token);
    setUser(data.user);
    return data.user;
  };

  const register = async (payload) => {
    const { data } = await api.post("/auth/register", payload);
    localStorage.setItem("pti_token", data.token);
    setUser(data.user);
    return data.user;
  };

  const logout = () => {
    localStorage.removeItem("pti_token");
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, register, logout, loginWithGoogleSession, selectRole, becomeCreator }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
